/**
 * @mergeTarget
 * @module Src/Parameters/Boolean
 */
import { LisioParameter } from "./lisio-parameter.js";
/**
 * Enumerator for all numeric parameters availables in Lisio
 * Please names new parameters as following :
 * ```
 * MY_NAME : "my_name"
 * ```
 * @source
 */
var LisioBooleanParameterNames;
(function (LisioBooleanParameterNames) {
    LisioBooleanParameterNames["VOCA"] = "voca";
    LisioBooleanParameterNames["SHOW_ALT"] = "show_alt";
    LisioBooleanParameterNames["HIGHLIGHT"] = "highlight";
    LisioBooleanParameterNames["DISABLE_ANIMATION"] = "disable_animation";
    LisioBooleanParameterNames["KEYBOARD_NAVIGATION"] = "keyboard_navigation";
    LisioBooleanParameterNames["READING_MASK"] = "reading_mask";
    LisioBooleanParameterNames["SPEECH_SYNTHESIS_STATE"] = "speech_synthesis_state";
    LisioBooleanParameterNames["LIST"] = "list";
    LisioBooleanParameterNames["BOOK_PAGE"] = "book_page";
    LisioBooleanParameterNames["IS_ACTIVE"] = "is_active";
    LisioBooleanParameterNames["ACTIVE_UNDERLINE"] = "active_underline";
    LisioBooleanParameterNames["READING_MODE"] = "reading_mode";
})(LisioBooleanParameterNames || (LisioBooleanParameterNames = {}));
/**
 * ## How to create a new (boolean) parameter ? Part 2
 *
 * To create a new boolean parameter is very easy, choose a revelant name and add it to {@link LisioBooleanParameterNames | LisioBooleanParameterNames}.\
 *
 * ## How to create a new (boolean) parameter ? Part 2
 *
 * If you want to rename it, choose a new revelant name and modify the old one in {@link LisioBooleanParameterNames | LisioBooleanParameterNames}.\
 * If you want change his type, see "How to delete" for current parameter and "How to create a new parameter" for new parameter.\
 *
 * ## How to delete a (boolean) parameter ? Part 2
 *
 * Delete his name from {@link LisioBooleanParameterNames | LisioBooleanParameterNames}.\
 *
 * ## Documentation
 *
 * Class representing a boolean parameter extending LisioParameter.\
 * It aims to centralize all the logic of boolean parameter.\
 * To execute his responsability this class does :
 *  * Saves name and value of boolean parameter
 */
class LisioBooleanParameter extends LisioParameter {
    /**
     * Protected attribute to store value of parameter
     * @source
     */
    _value;
    /**
     * Protected attribute to store default value of parameter
     * @source
     */
    _defaultValue;
    /**
     * Getter for attribute {@link _value | _value}
     * @returns Returns _value attribute
     * @source
     */
    get value() {
        return this._value;
    }
    /**
     * Getter for attribute {@link _defaultValue | _defaultValue}
     * @returns Returns _defaultValue attribute
     * @source
     */
    get defaultValue() {
        return this._defaultValue;
    }
    /**
     * Constructor of class {@link LisioBooleanParameter | LisioBooleanParameter}
     * @param {LisioBooleanParameterNames} name - Parameter name
     * @param {number} value - Parameter value
     * @source
     */
    constructor(name, value) {
        super(name);
        this._value = value;
        this._defaultValue = false;
    }
}
export { LisioBooleanParameter, LisioBooleanParameterNames };
